<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="nucForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                nucForm: () => import('../forms/NucForm'),
                headers: [
                    { text: 'Inspection', value: 'inspectionId', table: 'inspections', form: () => import('../forms/InspectionForm') },
                    { text: 'Number Of Frames', value: 'numberOfFrames' },
                    { text: 'Frame Type', value: 'frameType', format: this.formatEnum },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    inspections: [],
                    items: []
                },
                sorting: [
                    { column: "inspectionId", direction: "ascending" },
                ],
                itemsField: 'nucs',
                editPageName: 'nuc',
                apiMethod: 'Nucs',
                claimName: 'Nucs',
                formTitle: 'Nuc',
                excelTitle: 'Nucs',
                hasEditPage: false,
            }
        },
    };
</script>
